import { useEffect } from 'react';
import { Loader, Typography } from 'src/components/common';
import { useGetIdentity } from 'src/hooks';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TAppliedProgramsListRequest, TProgramListRequest } from 'src/services/apiEndpoint.types.ts';
import { allActiveProgramList, appliedProgramsList, incrementAppliedProgramsPage, incrementProgramsPage, programList } from 'src/store/program/program.slice';

import './appliedProgramsList.scss';

import AppliedProgramCard from '../appliedProgramCard/AppliedProgramCard';
import { Col, Row } from 'react-bootstrap';
import SuggestedProgramCard from '../suggestedProgramCard/SuggestedProgramCard';
import { getProgramForExternalUser } from 'src/store/externalProgram/externalProgram.slice';

const AppliedProgramsList = () => {
  // Hooks
  const dispatch = useAppDispatch();
  const { appliedProgramsPageNumber, appliedProgramsPerPage, appliedPrograms, programs, programsPageNumber, moreProgramsLeft, moreAppliedProgramsLeft } = useAppSelector(
    (store) => store.program
  );
  const loading = useAppSelector((state) => state.common.loading)

  const { getIdentities } = useGetIdentity();

  const { loggedInUserId } = getIdentities();

  const handleGetAppliedPrograms = () => {
    const payload: TAppliedProgramsListRequest = {
      userId: loggedInUserId,
      limit: appliedProgramsPerPage,
      offset: appliedProgramsPageNumber
    };

    dispatch(appliedProgramsList(payload));
  };
  function handleGetProgram() {
    const payload: TProgramListRequest = {
      limit: 20,
      offset: programsPageNumber
    }
    // dispatch(getProgramForExternalUser(payload));
    dispatch(allActiveProgramList(payload))
  }

  function handleIncreamentProgram() {
    dispatch(incrementProgramsPage(1));
  }
  function handleIncreamentAppliedProgram() {
    dispatch(incrementAppliedProgramsPage(1));
  }

  useEffect(() => {
    handleGetAppliedPrograms();
  }, [appliedProgramsPageNumber, appliedProgramsPerPage, loggedInUserId]);
  useEffect(() => {
    handleGetProgram()
  }, [programsPageNumber])

  console.log(programs, 'programs');

  return (
    <>
      {!loading && <div className="my-profile-applied-programs-list">
        <Typography variant="subHeading-2" fontWeight="semiBold">
          Applied Programs
        </Typography>
        <div className="my-profile-applied-programs-list__programs">
          {appliedPrograms.map((program, index) => (
            <AppliedProgramCard key={index} {...program} dataType={program.dataType || ''} draftData={program} />
          ))}
        </div>
        {appliedPrograms?.length === 0 && (
          <div className="my-profile-applied-programs-list__not-applied-message-box">
            <p>No program applied yet</p>
          </div>
        )}
        {moreAppliedProgramsLeft && <Row>
          <Col md={12} className='my-profile-applied-programs-list__see-more-button'>
            <span onClick={handleIncreamentAppliedProgram}>See more</span>
          </Col>
        </Row>}
        <Row className='mt-3'>
          <Col md={12} className='mb-3'>
            <Typography variant="subHeading-2" fontWeight="semiBold">
              Program Suggestions
            </Typography>
          </Col>
          {programs.map((program, i) => {
            return (
              <Col md={4} key={i}>
                <SuggestedProgramCard program={program} />
              </Col>
            )
          })}
        </Row>
        {moreProgramsLeft && <Row>
          <Col md={12} className='my-profile-applied-programs-list__see-more-button'>
            <span onClick={handleIncreamentProgram}>See more</span>
          </Col>
        </Row>}
      </div>}
      {loading && <Loader />}

    </>
  );
};

export default AppliedProgramsList;
